<template>
  <div>
    <headerArea></headerArea>
    <router-view/>
    <footerArea></footerArea>
  </div>
</template>

<script>
  import headerArea from '@/components/header.vue';
  import footerArea from '@/components/footer.vue';
  export default {
    components: {
      headerArea,
      footerArea
    },
    data() {
      return {
      }
    },
    methods: {

    },
    created() {
      console.log("main create")
      this.$router.push({
        name: 'index'
      })
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/main.vue